// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3256":"ba222cfe","5674":"ba222cfe","6014":"e28c2e3d","6905":"ba222cfe","8894":"ba222cfe"}[chunkId] + ".chunk.css";
};